import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output , ChangeDetectionStrategy } from '@angular/core';
import gsap from 'gsap';
import { GameType } from '../../../interfaces/gmsdata.interface';

@Component({
    selector: 'wab-game',
    templateUrl: './whack-a-bingo-game.component.html',
    styleUrls: ['./whack-a-bingo-game.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WhackABingoGameComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() gameImageAssets: any;
  @Input() wabTextColor: any;
  @Input() gWhackConfig: any;
  @Input() bonusData: any;
  @Output() SoundsData: EventEmitter<string> = new EventEmitter();
  @Output() gameEnd = new EventEmitter();
  @Output() gHitsUpdate = new EventEmitter();
  rabbitSpriteSheet = { width: 80, height: 80, total: 4, cols: 6, rows: 4, duration: .3 }; // 21
  rabbitSpriteSheet2 = { width: 80, height: 80, total: 21, cols: 6, rows: 4, duration: .3 }; // 21
  hammerSpriteSheet = { width: 120, height: 120, total: 7, cols: 3, rows: 2, duration: .2 }; // 7
  oopsSpriteSheet = { width: 120, height: 120, total: 40, cols: 8, rows: 5, duration: 1 }; // 40
  smokeSpriteSheet = { width: 152, height: 162, total: 34, cols: 7, rows: 5, duration: 1 }; // 34
  hitSpriteSheet = { width: 112, height: 72, total: 5, cols: 5, rows: 1, duration: .3 }; // 5

  gridPos = [
    { "top": "-25", "left": "15" }, { "top": "-25", "left": '125' }, { "top": "-25", "left": "235" },
    { "top": "45", "left": "15" }, { "top": "45", "left": '125' }, { "top": "45", "left": "235" },
    { "top": "115", "left": "15" }, { "top": "115", "left": '125' }, { "top": "115", "left": "235" },
    { "top": "185", "left": "15" }, { "top": "185", "left": '125' }, { "top": "185", "left": "235" },
  ];


  public pitsCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public GameType = GameType;

  animArea: any;
  wabbitTarget: any;

  hammerTarget: any;
  hammerArea: any;

  gameInterval: any;

  smokeTarget: any;
  smokeArea: any;

  oppsArea: any;
  oppsTarget: any;

  hitArea: any;
  hitTarget: any;

  scoreArea: any;
  scoreTxt: any;
  gameMode: any;

  wabbitInd = -1;
  hammerInd = -1;
  curRabbitIndex = -1;
  rabbitGotHit: boolean = false;
  hitTimeOut: boolean = false;
  isRabbitAwayStarted: boolean = false;

  hideCursorTimeout: any;
  clearRabbitAway: any;
  private _hammerAction: boolean = false;
  constructor() { }

  ngAfterViewInit(): void {
    try {
      if (this.detectDesktop()) {
        this.gameMode = document.querySelector('.playArea');
        let path = this.getImg("winBg");
        this.gameMode.style.cursor = `url(${path}) 15 30, pointer`;
        this.gameMode.addEventListener('mouseup', (event) => {
          if (this._hammerAction == false && (event.target.className == "wab-wabbitAnim" || event.target.className == "pitClick" || event.target.className == "animArea")) {
            this._hammerAction = true;
            this.hideCursorTimeout && clearTimeout(this.hideCursorTimeout);
            this.gameMode.style.cursor = 'none';
            this.hideCursorTimeout = setTimeout(() => {
              this._hammerAction = false;
              this.gameMode.style.cursor = `url(${path}) 15 30, pointer`;
            }, this.hammerSpriteSheet.duration * 1000);
          }
        });
      }
    } catch (error) {
      console.log("WAB:  mouseup event triggered", error);
    }
  }

  ngOnInit(): void {

    this.wabbitTarget = document.querySelector(".wab-wabbitAnim");
    this.animArea = document.querySelector(".animArea");

    this.smokeTarget = document.querySelector(".wab-smokeAnim");
    this.smokeArea = document.querySelector(".smokeArea");

    this.oppsTarget = document.querySelector(".wab-oopsAnim");
    this.oppsArea = document.querySelector(".oopsArea");

    this.hammerTarget = document.querySelector(".wab-hammerAnim");
    this.hammerArea = document.querySelector(".hammerArea");

    this.hitTarget = document.querySelector(".wab-hitAnim");
    this.hitArea = document.querySelector(".hitArea");

    this.scoreTxt = document.querySelector(".scoreTxt");
    this.scoreArea = document.querySelector(".scoreArea");

    clearInterval(this.gameInterval);
    this.wabbitInd = this.gWhackConfig.gameData.wabbitInd;
    this.playGame();
  }

  oppAnim() {
    this.SoundsData.emit("failedHit");
    this.setPos(this.oppsArea, this.gridPos[this.hammerInd]);
    this.playAnim(this.oopsSpriteSheet, this.oppsTarget);
  }

  smokeAnm() {
    this.setPos(this.smokeArea, this.gridPos[this.hammerInd]);
    this.playAnim(this.smokeSpriteSheet, this.smokeTarget);
  }

  playGame() {
    this.SoundsData.emit("bgMusic");
    this.gameInterval = setInterval(() => {
      if (this.wabbitInd == this.wabbitArr.length - 1) {
        clearInterval(this.gameInterval);
        setTimeout(() => { this.wabbitInd = -1; }, 1000);
      } else {
        this.showNextRabbit();
      }
    }, this.gWhackConfig.gameData.popupDelay * 1000);
  }

  showNextRabbit() {
    this.rabbitGotHit = false;
    this.hitTimeOut = false;
    this.isRabbitAwayStarted = false;
    this.wabbitInd++;
    this.curRabbitIndex = this.wabbitArr[this.wabbitInd].pos;
    this.SoundsData.emit("pop");
    this.setPos(this.animArea, this.gridPos[this.wabbitArr[this.wabbitInd].pos - 1]);
    this.playAnim(this.rabbitSpriteSheet, this.wabbitTarget, 0);

    this.clearRabbitAway = setTimeout(() => {
      if (!this.rabbitGotHit) {
        this.rabbitAway();
      }
    }, (this.rabbitSpriteSheet.duration + this.gWhackConfig.gameData.stayUpTime) * 1000);

    let dur = (this.rabbitSpriteSheet.duration + this.gWhackConfig.gameData.stayUpTime + this.rabbitSpriteSheet2.duration) - (this.hammerSpriteSheet.duration / 2);
    setTimeout(() => {
      this.hitTimeOut = true;
    }, (dur * 1000));
  }

  rabbitAway() {
    if (this.isRabbitAwayStarted) {
      return;
    }
    this.clearRabbitAway && clearTimeout(this.clearRabbitAway);
    this.isRabbitAwayStarted = true;
    this.playAnim(this.rabbitSpriteSheet2, this.wabbitTarget, 17);
  }

  onRabbitHit() {
    this.onHit(this.curRabbitIndex);
  }

  onHit(item: any) {
    this.hammerInd = item - 1;
    this.hammerArea.style.display = "block";
    this.setPos(this.hammerArea, this.gridPos[this.hammerInd]);
    // this.SoundsData.emit("hitMusic"); // currently Hit music is not playing in the client
    this.playAnim(this.hammerSpriteSheet, this.hammerTarget);

    if (this.hitTimeOut == false && this.wabbitArr[this.wabbitInd]?.hit != "true" && this.wabbitArr[this.wabbitInd]?.pos - 1 == this.hammerInd) {
      this.rabbitGotHit = true;
      this.wabbitArr[this.wabbitInd].hit = "true";
      this.rabbitHitScoreAnim();
      if (this.isRabbitAwayStarted == false) {
        this.rabbitAway();
      }
    } else {
      setTimeout(() => { this.oppAnim(); }, 100);
      if (this.wabbitArr[this.wabbitInd]?.hit == "") {
        this.wabbitArr[this.wabbitInd].hit = "false";
      }
    }

    gsap.delayedCall(1, this.hideScore.bind(this));
    this.smokeAnm();
  }

  setPos(obj, val, gap = 0) {
    obj.style.top = (Number(val.top) + gap) + "px";
    obj.style.left = (Number(val.left) + gap) + "px";
  }

  rabbitHitScoreAnim() {
    this.SoundsData.emit("successHit");
    this.setPos(this.hitArea, this.gridPos[this.hammerInd]);
    this.playAnim(this.hitSpriteSheet, this.hitTarget);
    this.setPos(this.scoreArea, this.gridPos[this.hammerInd]);
    this.scoreArea.style.display = 'block';
    gsap.to(".scoreArea", { scale: 1, duration: 1, ease: "bounce.out", onComplete: this.hideScore.bind(this) });
    this.gHitsUpdate.emit();
  }

  hideScore() {
    gsap.to(".scoreArea", { scale: 0.001, duration: 0.01 });
  }

  get score(): number {
    return this.gWhackConfig.gameData.score; // '13';
  }
  get reward(): string {
    return this.gWhackConfig.gameData.reward;
  }
  get ticketsCount(): number {
    return this.gWhackConfig.gameData.ticketsCount; //'20';
  }
  get prize() {
    return this.getExchangeAmount(Number.parseFloat(String(this.gWhackConfig.gameData.prize)).toFixed(2)); //'15';
  }
  get hitPoints() {
    return this.gWhackConfig.gameData.hitPoints;
  }

  get bonusType(): string {
    return this.bonusData;
  }

  get isPointType(): boolean {
    return this.gWhackConfig.gameData.isPointType;
  }

  get currentGameType(): boolean {
    return this.gWhackConfig.gameData.gameType;
  }

  get wabbitArr(): any[] {
    return this.gWhackConfig.gameData.popOutSequence;
  }

  get introTxtColor(): string {
    return this.wabTextColor;
  }

  getImg(name: string): string {
    return this.gameImageAssets[name];
  }

  getTranslation(data) {
    let translateData = {
      "wab_score_in_play": "Score: ",
      "wab_reward_in_play": "Reward: ",
      "wab_prize_in_play": "Prize: ",
      "wab_number_tickets_in_play": "No. of tickets: ",
      "Bingo bonus": "BONUS",
      "Free Bingo Tickets": "FREE TICKETS",
      "Free Spins": "FREE SPINS",
    }
    if (this.bonusType != 'cash') {
      return translateData[data];
    }
    return ''
  }
  getCurrencySymbol(bonusType) {
    let bool = false;
    if (bonusType == 'cash' || bonusType == "bingo_bonus") {
      bool = true;
    }
    return bool;
  }
  playAnim(spriteSheet: any, target: any, startPos: number = 0) {
    target.style.display = "block";

    gsap.set(target, { force3D: true });
    var tl = gsap.timeline({ repeat: 0, });

    for (var i = startPos; i < spriteSheet.total; i++) {
      tl.set(target, {
        x: (i % spriteSheet.cols) * -spriteSheet.width,
        y: Math.floor(i / spriteSheet.cols) * -spriteSheet.height
      }, i / (spriteSheet.total - 1) * spriteSheet.duration);
    }
  }

  onClose() {
    console.log("Closedd...");
  }

  onGameEnd() {
    this.gameEnd.emit();
  }

  detectDesktop(): boolean {
    return !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i.test(navigator.userAgent));
  }

  getExchangeAmount(amt) {
    return (this.gWhackConfig.exchangeRate ? this.roundTwoPlaces((amt * this.roundTwoPlaces(this.gWhackConfig.exchangeRate))) : amt);
  }

  roundTwoPlaces(num) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }
  ngOnDestroy(): void {
    clearInterval(this.gameInterval);
  }

}
